import { useQuery } from "@tanstack/react-query"

export function useIpAddressQuery() {
  return useQuery({
    queryKey: ["ip-address"],
    queryFn: async () => {
      const response = await fetch("https://checkip.amazonaws.com")

      if (!response.ok) {
        throw new Error("Network response was not ok")
      }

      const text = await response.text()
      return text.trim()
    },
    meta: { preventGlobalError: true },
    staleTime: Infinity,
  })
}
